export function isNumber(value: string) {
    return (
        /^[1-9]\d{0,2}(,\d{3})*(\.\d+)?$/.test(value) ||
        /^[1-9]\d*(\.\d+)?$/.test(value) ||
        /^0(\.\d+)?$/.test(value)
    );
}

export function toNumber(value: string) {
    if (!isNumber(value)) {
        return NaN;
    }
    return +value.replace(/,/g, '');
}
